import { createSelector } from '@reduxjs/toolkit';

export const getBrandsSeo = createSelector(
	state => state.profile,
	profile => profile.seo,
);
